<template>
  <li
    ref="menuItemRef"
    :class="[
      'gfr-menu-item',
      asTrigger && 'gfr-menu-item--trigger group',
      'hover:text-primary-hover data-[state=open]:text-primary-hover'
    ]"
    data-state="close"
    @mouseleave="asTrigger && hoverTrigger(false)"
    @mouseenter="asTrigger && hoverTrigger(true)"
  >
    <slot />
  </li>
</template>
<script lang="ts" setup>
const route = useRoute()
defineProps({
  asTrigger: Boolean
})
const menuItemRef = ref<HTMLElement>()
function hoverTrigger(bool: boolean) {
  if (menuItemRef.value) {
    menuItemRef.value.dataset.state = bool ? 'open' : 'close'
  }
}
watch(
  () => route.params,
  () => {
    hoverTrigger(false)
  }
)
</script>
